import { Injectable, PLATFORM_ID, inject, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export interface SiteContent {
  aboutTitle: string;
  aboutText: string;
}

@Injectable({ providedIn: 'root' })
export class SiteContentService {
  private readonly platformId = inject(PLATFORM_ID);
  readonly content = signal<SiteContent>(this.read());

  save(payload: SiteContent): void {
    this.content.set(payload);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('siteContent', JSON.stringify(payload));
    }
  }

  private read(): SiteContent {
    const fallback: SiteContent = {
      aboutTitle: 'About Us',
      aboutText: "Magazine/Publication, celebrating the richness of Indian literature and thought since 1985."
    };

    if (!isPlatformBrowser(this.platformId)) return fallback;
    try {
      const raw = localStorage.getItem('siteContent');
      return raw ? ({ ...fallback, ...(JSON.parse(raw) as Partial<SiteContent>) } as SiteContent) : fallback;
    } catch {
      return fallback;
    }
  }
}
